<div class="test-card-loader-container">
  <div class="test-card-loader" *ngFor="let i of [].constructor(count)">
    <div class="title-loader">
      <div class="status-icon-loader"></div>
      <div class="name-loader"></div>
    </div>
    <div class="info-loader">
      <div class="timestamp-loader"></div>
    </div>
  </div>
</div>
